import {Person as PersonIcon} from '@mui/icons-material';
import {Avatar} from '@mui/material';
import PropTypes from 'prop-types';
import React, {memo} from 'react';

import {getUserInitials} from './utils.js';

/**
 * Avatar representing a logged in Planet user
 */
export const UserAvatar = ({user, size = 'medium'}) => {
  const userInitials = getUserInitials(user);

  return (
    <Avatar
      color="primary"
      size={size}
      aria-label={user ? `Avatar for ${user.email}` : 'user avatar'}
      sx={{
        fontWeight: 'fontWeightMedium',
        background: theme =>
          `linear-gradient(138.09deg, ${(theme.vars || theme).palette.primary.light} 55%, ${(theme.vars || theme).palette.primary.main} 100%)`,
      }}
    >
      {userInitials || <PersonIcon />}
    </Avatar>
  );
};

UserAvatar.propTypes = {
  /**
   User object from auth
  */
  user: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
  }),
  /**
    Avatar Size
  */
  size: PropTypes.string,
};

export default memo(UserAvatar);
